var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-card',{attrs:{"elevation":"0","max-width":"1024"}},[_c('PicturePage'),_c('QuizPanel')],1),_c('BuzzIn')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }